import { PaymentMethod } from "../interfaces/accounting/PaymentMethod";
import { CustomerType } from "../interfaces/jobsheets/ICustomer";

export const GetCustomerFriendlyString = (type: CustomerType | undefined): string => {
    let output: string = "Unkown";

    if (type !== undefined){
        if (type == CustomerType.Domestic) output = "Domestic"
        else if (type in [CustomerType.PublicSector, CustomerType.PrivateBusiness]) output = "Business"
        else if (type == CustomerType.Premium) output = "Account"
    }

    return output;
}